/**
 * Validációs hibaüzenetek - űrlap validáció
 *
 * Namespace: validation
 */
export const validation = {
  // Általános
  required: "Ez a mező kötelező",

  // Email
  email: "Érvénytelen email cím",

  // Hossz
  minLength: (min: number) => `Legalább ${String(min)} karakter szükséges`,
  maxLength: (max: number) => `Maximum ${String(max)} karakter engedélyezett`,

  // Jelszó
  passwordMin: "A jelszónak legalább 8 karakterből kell állnia",
  passwordMatch: "A jelszavak nem egyeznek",

  // Regisztráció specifikus
  acceptPrivacyPolicy: "El kell fogadnod az adatvédelmi szabályzatot",
  acceptTermsOfService: "El kell fogadnod a felelősségi nyilatkozatot",
  organizationRequired: "Szervezeti regisztrációhoz kötelező megadni a szervezet nevét",
} as const;

export type ValidationMessages = typeof validation;
